<template>
    <div class="card-header"><slot /></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({ name: 'CCardHeader' });
</script>
